/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutboundPlanScanOrder
 */
export interface OutboundPlanScanOrder {
    /**
     * 订单ID
     * @type {number}
     * @memberof OutboundPlanScanOrder
     */
    orderId?: number;
    /**
     * 订单号
     * @type {string}
     * @memberof OutboundPlanScanOrder
     */
    orderCode?: string;
    /**
     * 国际运输方式
     * @type {string}
     * @memberof OutboundPlanScanOrder
     */
    internationalTransportMethodName?: string;
    /**
     * 是否为Rocket订单
     * @type {boolean}
     * @memberof OutboundPlanScanOrder
     */
    isRocket?: boolean;
    /**
     * 唛头号列表
     * @type {Array<string>}
     * @memberof OutboundPlanScanOrder
     */
    markNoList?: Array<string>;
}

/**
 * Check if a given object implements the OutboundPlanScanOrder interface.
 */
export function instanceOfOutboundPlanScanOrder(value: object): value is OutboundPlanScanOrder {
    return true;
}

export function OutboundPlanScanOrderFromJSON(json: any): OutboundPlanScanOrder {
    return OutboundPlanScanOrderFromJSONTyped(json, false);
}

export function OutboundPlanScanOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundPlanScanOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'internationalTransportMethodName': json['internationalTransportMethodName'] == null ? undefined : json['internationalTransportMethodName'],
        'isRocket': json['isRocket'] == null ? undefined : json['isRocket'],
        'markNoList': json['markNoList'] == null ? undefined : json['markNoList'],
    };
}

export function OutboundPlanScanOrderToJSON(json: any): OutboundPlanScanOrder {
    return OutboundPlanScanOrderToJSONTyped(json, false);
}

export function OutboundPlanScanOrderToJSONTyped(value?: OutboundPlanScanOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'internationalTransportMethodName': value['internationalTransportMethodName'],
        'isRocket': value['isRocket'],
        'markNoList': value['markNoList'],
    };
}

